// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-pills .nav-link,\r\n.nav-tabs .nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\n}\r\n", ""]);
// Exports
module.exports = exports;
